/* global axios */
import ApiClient from './ApiClient';

class AgendaAPI extends ApiClient {
  constructor() {
    super('agenda_events', { accountScoped: true });
  }

  complete(id) {
    return axios.patch(`${this.url}/${id}/complete`);
  }
}

export default new AgendaAPI();
